import axios from 'axios';
import { getUserById } from 'api/user';
import { useQuery } from '@tanstack/react-query';
import { User } from 'types/user';

const missingError = (error: Error) => {
  if (axios.isAxiosError(error)) {
    return error.response?.status === 404;
  }
  return true;
};

export function useUser(userId: string | undefined) {
  const queryResponse = useQuery<User>(
    ['user', userId],
    () => getUserById(userId || ''),
    {
      enabled: !!userId,
      retry: (failureCount, error) => {
        return !missingError(error as Error) && failureCount < 3;
      },
      useErrorBoundary: (error: unknown) => !missingError(error as Error),
    }
  );

  return {
    user: queryResponse.data,
    userLoading: queryResponse.isLoading,
    userFetching: queryResponse.isFetching,
    refetchUser: queryResponse.refetch,
  };
}
